<!-- <div class="form-header m-b-20">
    <h2 class="f-w-500" mat-dialog-title><strong>Change Password</strong></h2>
    <mat-icon class="close-sym cursor-pointer" (click)="closeDialog()">close</mat-icon>
  </div> -->

<div class="f_model_header">
    <div class="d-flex align-items-center justify-content-between">
        <h4>Change Password</h4>
        <div class="d-flex align-items-center gap-8 fields-Dropdown">
            <button class="f_close_new_model" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<mat-dialog-content style="max-width: 500px; max-height: 600px; overflow: auto;">

    <form #locationForm="ngForm">
        <div class="row m-b-20">

            <div class="col-lg-12">
                <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-8">Current Password<span class="text-error">*</span></mat-label>
                <mat-form-field appearance="outline" class="w-100">
                    <input type="password" matInput required id="oldPassword" name="oldPassword" [(ngModel)]="oldPassword" placeholder="Enter Current Password" #oldpasswordField="ngModel" [type]="hidePassword ? 'password' : 'text'" />
                    <mat-icon matSuffix (click)="hidePassword = !hidePassword">
                          <i-tabler [name]="hidePassword ? 'eye-off' : 'eye'" class="icon-20 op-5 cursor-pointer"></i-tabler>
                        </mat-icon>
                        <mat-error *ngIf="oldpasswordField.invalid && oldpasswordField.touched">
                          Password is required
                        </mat-error>
                </mat-form-field>
            </div>

            <div class="col-lg-12">
                <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-8">New Password<span class="text-error">*</span></mat-label>
                <mat-form-field appearance="outline" class="w-100">
                    <input type="password" matInput required id="newPassword" name="newPassword" [(ngModel)]="newPassword" placeholder="Enter New Password" #newpasswordField="ngModel" [type]="hideNewPassword ? 'password' : 'text'" />
                    <mat-icon matSuffix (click)="hideNewPassword = !hideNewPassword">
                          <i-tabler [name]="hideNewPassword ? 'eye-off' : 'eye'" class="icon-20 op-5 cursor-pointer"></i-tabler>
                        </mat-icon>
                        <mat-error *ngIf="newpasswordField.invalid && newpasswordField.touched">
                          Password is required
                        </mat-error>
                </mat-form-field>
            </div>

            <div class="col-lg-12">
                <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-8">Confirm Password<span class="text-error">*</span></mat-label>
                <mat-form-field appearance="outline" class="w-100">
                    <input type="password" matInput required id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword" placeholder="Enter Confirm Password" #confirmpasswordField="ngModel" [type]="hideConfirmPassword ? 'password' : 'text'" />
                    <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword">
                          <i-tabler [name]="hideConfirmPassword ? 'eye-off' : 'eye'" class="icon-20 op-5 cursor-pointer"></i-tabler>
                        </mat-icon>
                        <mat-error *ngIf="confirmpasswordField.invalid && confirmpasswordField.touched">
                          Password is required
                        </mat-error>
                </mat-form-field>
            </div>

        </div>

        <div class="d-flex justify-content-end">
        <button mat-flat-button (click)="Submit()" color="primary" [disabled]="!locationForm.valid">
           Update
        </button>
        <button mat-stroked-button color="warn" class="m-l-8" (click)="closeDialog()">
            Cancel
        </button>
        </div>
    </form>
</mat-dialog-content>